module.exports = __webpack_public_path__ + "static/media/logomarca-jnnet.302c7d64.svg";